import React from 'react';
// import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import template from '../../../templates/PageLayout/Popups/AssignCategoryImagePopup.rt';

import { postQtCategory, toggleQtCategoryImagePopup } from "../../../components/NewScope/newScopeActions";
import {ProjectScopeIcons} from "../../ProjectScope/NewFeatureGroup";
import {getIconStyles} from "../../../utilities/iconSizes";

class AssignCategoryImagePopup extends React.Component {

  static propTypes = {
    // fetchFabricator: PropTypes.func.isRequired,
    // setSearchTerm: PropTypes.func.isRequired,
    // onLoadEditor: PropTypes.func.isRequired,
    // onUnloadEditor: PropTypes.func.isRequired
  };

  state = {
    headerText: "Add Icon"
  };

  editQtCategoryImage = (qtCategoryImageEditIndex) => {
    this.props.toggleQtCategoryImagePopup(qtCategoryImageEditIndex)
  };

  isSelectedImage = (image) => {
    const bgImageUrl = this.props.qtCategories[this.props.qtCategoryImageEditIndex]
      && this.props.qtCategories[this.props.qtCategoryImageEditIndex].bgImageUrl;
    return bgImageUrl === image
  };

  isLastImage = (imageIndex) => {
    const allItemsLength = ProjectScopeIcons.length;
    return imageIndex >= allItemsLength - (allItemsLength % 7); // should be imageIndex > 82 - 5 // 5 is rest after divide
  };

  getImageStyle = (image) => {
    return getIconStyles(image);
  };

  handleClose = () => {
    this.props.toggleQtCategoryImagePopup(null);
  };

  selectCategoryImage = (image) => {
    const category = this.props.qtCategories[this.props.qtCategoryImageEditIndex];
    category.bgImageUrl = `/content/views/dashboard/images/icons/pj-scope-icons/enabled/${image}`;
    this.props.postQtCategory(category);
    this.handleClose();
  };

  render() {
    return template.call(this)
  }
}

const mapStateToProps = (store) => {
  return {
    qtCategories: store.newScope.qtCategories,
    qtCategoryImageEditIndex: store.newScope.qtCategoryImageEditIndex
  };
};

export default connect(mapStateToProps, {
  postQtCategory,
  toggleQtCategoryImagePopup
})(AssignCategoryImagePopup);
